import React from "react";
interface SlideProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  content: React.ReactNode;
}
export const Slide = ({
  title,
  subtitle,
  icon,
  content
}: SlideProps) => {
  return <div className="bg-white rounded-xl p-8 shadow-lg min-h-[600px]" data-id="element-1423">
      <div className="text-center mb-8" data-id="element-1424">
        {icon && <div className="flex justify-center mb-4" data-id="element-1425">{icon}</div>}
        <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1426">{title}</h2>
        {subtitle && <p className="text-xl text-gray-600" data-id="element-1427">{subtitle}</p>}
      </div>
      <div className="max-w-5xl mx-auto" data-id="element-1428">{content}</div>
    </div>;
};